
import { Component } from '@angular/core';

@Component({
  selector: 'timeout.page',
  templateUrl: './timeout.page.html',
})
export class TimeOutPage { }
